class PhoneNr extends React.Component {

    render() {
        var nr = this.props.nr;



        if (nr.length === 10) {
            var nr = nr.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
        }

        nr = nr.replace(/[^a-zA-Z0-9]/g, '');

        if (nr.length === 1 || nr.length === 2)
            nr = nr;
        else if (nr.length === 3)
            nr = '('+nr;
        else if (nr.length === 4 || nr.length === 5 || nr.length === 6)
            nr = '('+nr.substr(0, 3)+') '+nr.substr(3, nr.length-1);
        else if (nr.length === 7 || nr.length === 8 || nr.length === 9 || nr.length === 10)
            nr = '('+nr.substr(0, 3)+') '+nr.substr(3, 3)+'-'+nr.substr(6, nr.length-1);

        return (
            <span>
                {nr}
            </span>
        );

    }
}

export default PhoneNr;


// WEBPACK FOOTER //
// ./ui_src/app/components/form/PhoneNr.react.jsx